import React from 'react';
import { AdminBlog } from '@/components/admin/AdminBlog';

const AdminBlogPage = () => {
  return <AdminBlog />;
};

export default AdminBlogPage;